import { call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";

import { API_BASE_URL, getRequest, postRequest } from "../../../api";
import {
    FETCH_FORMATION_BOOKMARKS_REQUEST,
    TOGGLE_FORMATION_BOOKMARK_REQUEST,
    fetchFormationBookmarksFail,
    fetchFormationBookmarksSuccess,
    toggleFormationBookmarkFail,
    toggleFormationBookmarkSuccess,
} from "../actions/formationBookmarksActions";

const extractErrorMessage = (error, fallback) => {
    const data = error?.response?.data;
    if (data?.message) return String(data.message);
    if (data?.error) return String(data.error);
    if (error?.message) return String(error.message);
    return fallback;
};

export function* fetchFormationBookmarksSaga(action) {
    const campagneId = action.payload?.campagneId;
    if (!campagneId) {
        yield put(fetchFormationBookmarksSuccess(campagneId, []));
        return;
    }

    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    const url = `${API_BASE_URL}/api/formation-bookmarks/campagne/${campagneId}`;

    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchFormationBookmarksSuccess(campagneId, resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement favoris formations");
        yield put(fetchFormationBookmarksFail(campagneId, msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    }
}

export function* toggleFormationBookmarkSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    const { campagneId, formationId, formation } = action.payload || {};
    const url = `${API_BASE_URL}/api/formation-bookmarks/toggle`;

    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: { campagneId, formationId },
            headers: { uid },
        });
        yield put(toggleFormationBookmarkSuccess({ ...(resp.data || {}), formation }));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur sauvegarde formation");
        yield put(toggleFormationBookmarkFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    }
}

export default function* watchFormationBookmarksSaga() {
    yield takeLatest(FETCH_FORMATION_BOOKMARKS_REQUEST, fetchFormationBookmarksSaga);
    yield takeLatest(TOGGLE_FORMATION_BOOKMARK_REQUEST, toggleFormationBookmarkSaga);
}
